import React from 'react';
import {
  Typography,
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  IconButton,
  // CardMedia,
} from '@material-ui/core';

import { useTranslation } from 'react-i18next';
// import useScreen from 'hooks/useScreen';
import Eric from 'public/images/eric.jpg';
// import Marco from 'public/images/marco.jpg';
import Angel from 'public/images/angel.jpg';
import CD from 'public/images/cd.jpg';
import Keith from 'public/images/keith.jpg';
import Greg from 'public/images/greg.jpg';
import Icon from 'sharedComponents/Icon';
import Seo from 'sharedComponents/Seo';

import useStyles from './useStyles';

const AboutUs = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  // const { isMobile } = useScreen();

  const STAFF = [
    {
      id: 1,
      name: 'Eric Mager',
      position: t('components.AboutUs.position.founder'),
      avatar: Eric,
      linkedin: '//linkedin.com/in/eric-mager',
    },
    {
      id: 3,
      name: 'Angel Rutledge',
      position: t('components.AboutUs.position.advisor'),
      avatar: Angel,
      linkedin: '//linkedin.com/in/angelrutledge/',
    },
    {
      id: 4,
      name: 'CD Davies',
      position: t('components.AboutUs.position.advisor'),
      avatar: CD,
      linkedin: '//linkedin.com/in/c-d-davies/',
    },
    {
      id: 5,
      name: 'Keith Luedeman',
      position: t('components.AboutUs.position.advisor'),
      avatar: Keith,
      linkedin: '//linkedin.com/in/keithluedeman/',
    },
    {
      id: 6,
      name: 'Greg Richardson',
      position: t('components.AboutUs.position.advisor'),
      avatar: Greg,
      linkedin: '//linkedin.com/in/greg-richardson-8a11396/',
    },
  ];

  return (
    <div className={classes.container}>
      <Seo title={t('meta.AboutUs.title')} />
      <div className={classes.content}>
        <Typography variant="h1" className={classes.header}>
          {t('components.AboutUs.header')}
        </Typography>
        <List className={classes.staffList}>
          {STAFF.map(({ name, position, avatar, id, linkedin }) => (
            <ListItem key={id} className={classes.staffItem}>
              <ListItemAvatar>
                <Avatar alt={name} src={avatar} className={classes.avatar} variant="rounded" />
              </ListItemAvatar>
              <ListItemText className={classes.text}>
                <Typography component="p" variant="body2" className={classes.name}>
                  {name}
                </Typography>
                <Typography component="p" variant="body2" className={classes.position}>
                  {position}
                </Typography>
                <IconButton
                  aria-label="Linkedin.com"
                  onClick={() => window.open(linkedin, '_blank')}
                  className={classes.socialButton}
                >
                  <Icon name="linkedin" />
                </IconButton>
              </ListItemText>
            </ListItem>
          ))}
        </List>
        <div className={classes.description}>
          <div className={classes.textBlock}>
            <List className={classes.descriptionList}>
              <ListItem className={classes.descriptionItem}>
                <Typography component="h3" className={classes.descriptionTitle}>
                  {t('components.AboutUs.description.firstSection.title')}
                </Typography>
                <Typography component="p" className={classes.descriptionText}>
                  {t('components.AboutUs.description.firstSection.text')}
                </Typography>
              </ListItem>
              <ListItem className={classes.descriptionItem}>
                <Typography component="h3" className={classes.descriptionTitle}>
                  {t('components.AboutUs.description.secondSection.title')}
                </Typography>
                <Typography
                  component="p"
                  className={classes.descriptionText}
                  dangerouslySetInnerHTML={{
                    __html: t('components.AboutUs.description.secondSection.text'),
                  }}
                />
              </ListItem>
            </List>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;



// WEBPACK FOOTER //
// ./src/components/AboutUs/AboutUs.js